import * as React from "react";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "@/components/ui/react-select";

export type SparkSpreadFuturesContractType = "Month" | "Quarter" | "Year";

interface SparkSpreadFuturesContractTypesSelectProps {
  selectedContractTypes: SparkSpreadFuturesContractType[];
  setSelectedContractTypes: React.Dispatch<React.SetStateAction<SparkSpreadFuturesContractType[]>>;
}

export function SparkSpreadFuturesContractTypesSelect(props: SparkSpreadFuturesContractTypesSelectProps) {
  const { t } = useTranslation();
  const options = [
    { value: "Month", label: "Month" },
    { value: "Quarter", label: "Quarter" },
    { value: "Year", label: "Year" },
  ];

  return (
    <MultiSelect
      isMulti
      options={options}
      value={options.filter((option) =>
        props.selectedContractTypes.includes(option.value as SparkSpreadFuturesContractType),
      )}
      onChange={(selectedOptions) => {
        const selectedValues = selectedOptions.map((option) => option.value as SparkSpreadFuturesContractType);
        props.setSelectedContractTypes(selectedValues);
      }}
      placeholder={t("Select contract types")}
      className="w-full"
    />
  );
}
